module.exports = __webpack_public_path__ + "static/Bottom-backg-fe93ee737fe23d4421f34085f6161b85.png";